import React, { useState } from 'react'
import _ from 'lodash/fp'
import Button from '@material-ui/core/Button'
import Snackbar from '@material-ui/core/Snackbar'
import {Helmet} from 'react-helmet'
import * as Colors from '../../../common/colors'
const paths = [
  'response.data.error.message',
  'response.data.data.message',
  'response.data.message',
  'response.data',
  'message',
  'errorMessage'
]

export const errorGetter = (error) =>
  _.flow(
    _.find((el) => _.get(el, error)),
    _.get(_, error),
    (val) => (_.isString(val) ? val : 'Disculpe. Hubo un error.'),
  )(paths)

export default (props) => {
  const [snackbarOpen, setSnackbarOpen] = React.useState(false)

  const error = props.error || props.history.location.state
  const stringifiedError = JSON.stringify(error, null, 2)
  const alternativeMessage = 'Error. Ver detalles de error'
  const detailedStateErrorMessage = _.get('history.location.state.detailedErrorMessage', props)

  const handleClick = () => {
    setSnackbarOpen(true)
    // TODO: migrar a Clipboard API cuadno la API esté madura
    const textArea = document.createElement('textarea')
    textArea.textContent = stringifiedError
    textArea.style = 'position: absolute;left: -100%;'
    document.body.append(textArea)
    textArea.select()
    textArea.setSelectionRange(0, 99999) /* For mobile devices */
    document.execCommand('copy')
    textArea.remove()
  }

  const handleClose = () => {
    setSnackbarOpen(false)
  }

  const [collapsed, setCollapsed] = useState(true)

  const message = _.flow(
    _.find((el) => _.get(el, error)),
    _.get(_, error),
    (val) => (_.isString(val) ? val : alternativeMessage),
  )(paths)

  const displayExtraMessage = detailedStateErrorMessage || props.detailedErrorMessage || message || stringifiedError
  return (
    <div className="api-error-message" style={{ position: 'relative' }}>
      <Helmet>
          <title>Asofix - ERROR</title>
      </Helmet>
      <p>{message || alternativeMessage}</p>
      <Button variant="outlined" color="primary" onClick={() => setCollapsed(!collapsed)}>
        Ver detalles de error
      </Button>
      {props.retryCallback && (
        <Button variant="outlined" color="primary" onClick={props.retryCallback}>
          Reintentar
        </Button>
      )}
      {displayExtraMessage && (
        <pre
          className="api-error-message-detail"
          onClick={handleClick}
          style={{
            overflow: collapsed ? 'hidden' : 'scroll',
            height: collapsed ? 0 : '50vh',
            width: '95%',
            backgroundColor: Colors.COLOR_FONDO_BLANCO,
            margin: '1rem 0rem',
            padding: collapsed ? '0 1rem' : '1rem',
            position: 'absolute',
            zIndex: 1,
            border: collapsed ? '' : 'solid 3px #000000',
          }}
        >
          {'MENSAJE: ' + (detailedStateErrorMessage || props.detailedErrorMessage || message) + '\n'}
          {stringifiedError}
        </pre>
      )}
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={snackbarOpen}
        onClose={handleClose}
        ContentProps={{
          'aria-describedby': 'Texto copiado al portapapeles',
        }}
        message={<span>Texto copiado al portapapeles</span>}
      />
    </div>
  )
}
